import { render } from "./PolicyImage.vue?vue&type=template&id=60890940&scoped=true"
import script from "./PolicyImage.vue?vue&type=script&lang=js"
export * from "./PolicyImage.vue?vue&type=script&lang=js"

import "./PolicyImage.vue?vue&type=style&index=0&id=60890940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60890940"]])

export default __exports__